import { forwardRef } from 'react';
import cx from './cx';

// Icon-only button. `label` is REQUIRED — it is the accessible name.
const IconButton = forwardRef(function IconButton({ label, size = 'md', className, children, type = 'button', ...rest }, ref) {
  return (
    <button
      ref={ref}
      className={cx('btn-icon', size === 'sm' && 'btn-icon--sm', className)}
      type={type}
      aria-label={label}
      title={label}
      {...rest}
    >
      {children}
    </button>
  );
});

export default IconButton;
